module.exports = __webpack_public_path__ + "media/application/images/icons/filter-dbd1e22d309b8a8cc2c6fb46c66eda13.svg";